module.exports = __webpack_public_path__ + "media/images/application/template/logos/hae-logo-1d76cebdef8b211d21ee6680331149dc.png";